import styled from '@emotion/styled'

export const PeriodNavigationWrapper = styled.div`
  display: flex;
`

export const NavigationLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
`
